import {Box, IconButton} from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import React from "react";
import {EetsDeviceHistoryEntry} from "../../../../app/api/model/eetsDevice";
import {DeviceHistoryEntry} from "../../../../app/api/model/deviceHistory";
import {useTranslation} from "react-i18next";

export interface JsonViewButtonProps {
    entry: EetsDeviceHistoryEntry | DeviceHistoryEntry;
    onOpenJsonView: (jsonObj: object) => void;
}

const JsonViewButton = ({onOpenJsonView, entry}: JsonViewButtonProps) => {
    const {t} = useTranslation();
    return (
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <IconButton title={t("generic_viewJson")} onClick={() => onOpenJsonView(JSON.parse(entry.information))}>
                <CodeIcon />
            </IconButton>
        </Box>
    );
};
export default JsonViewButton;
